var app = angular.module('calcbtc', [
  'ngRoute',
  'googlechart',
  'chart.js',
  'cgBusy',
  'ngAnimate',
  'pascalprecht.translate']);

  app.config(['$translateProvider', function($translateProvider) {

  }]);

module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./app/js/manager-module.js
// module id = 1
// module chunks = 0